"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _JsonSchema = require("../JsonSchema");

var _lodash = _interopRequireDefault(require("lodash.clonedeep"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var MODELS = {};
var SCHEMA_ID_TO_MODEL_NAME = {};

var isArray = function isArray(o) {
  if (!o) {
    return false;
  }

  return _typeof(o) === "object" && o.length !== undefined;
};

var IsEmptyValue = function IsEmptyValue(value, schema) {
  if (!value) {
    return true;
  }

  if (schema.id || schema["$ref"]) {
    var schemaId = schema.id || schema["$ref"];

    if (SCHEMA_ID_TO_MODEL_NAME[schemaId]) {
      return value.isEmpty();
    }

    return true;
  }

  if (schema.type === "array") {
    if (isArray(value)) {
      for (var i = 0; i < value.length; i++) {
        if (!IsEmptyValue(value[i], schema.items)) {
          return false;
        }
      }
    }

    return true;
  }

  if (schema.type === "object") {
    var isEmpty = true;

    if (_typeof(value) === "object") {
      Object.keys(value).forEach(function (key) {
        if (!schema.properties[key]) {
          return true;
        }

        if (!IsEmptyValue(value[key], schema.properties[key])) {
          isEmpty = false;
          return false;
        }
      });
    }

    return isEmpty;
  }

  return false;
};

var ConstructValue = function ConstructValue(value, schema) {
  if (!value) {
    return value;
  }

  if (schema.anyOf) {
    var constructedValue = null;
    var matchingSchema = schema.anyOf.find(function (schemaOf) {
      return schemaOf["$ref"] && "/" + value.__class_name === schemaOf["$ref"];
    });

    if (matchingSchema) {
      return ConstructValue(value, matchingSchema);
    }

    schema.anyOf.forEach(function (schemaOf) {
      if (ValidateObject(value, schemaOf).valid) {
        constructedValue = ConstructValue(value, schemaOf);
        return false;
      }

      return true;
    });
    return constructedValue || value;
  }

  if (schema.id || schema["$ref"]) {
    var schemaId = schema.id || schema["$ref"];

    if (SCHEMA_ID_TO_MODEL_NAME[schemaId]) {
      var ModelName = SCHEMA_ID_TO_MODEL_NAME[schemaId];

      if (MODELS[ModelName]) {
        var objectValue = new MODELS[ModelName].__class.prototype.constructor();
        objectValue.setData(value);
        return objectValue;
      }
    }
  }

  if (schema.type === "array") {
    var valueArray = [];

    if (isArray(value)) {
      for (var i = 0; i < value.length; i++) {
        valueArray.push(ConstructValue(value[i], schema.items));
      }
    }

    return valueArray;
  }

  if (schema.type === "object") {
    var valueObject = {};

    if (_typeof(value) === "object") {
      Object.keys(value).forEach(function (key) {
        if (!schema.properties[key]) {
          return true;
        }

        valueObject[key] = ConstructValue(value[key], schema.properties[key]);
      });
    }

    return valueObject;
  }

  return value;
};

var ExportValue = function ExportValue(value) {
  // Is Object
  if (value instanceof AbstractObject) {
    return value["export"](); // Is Array
  } else if (isArray(value)) {
    var valueArray = [];

    for (var i = 0; i < value.length; i++) {
      valueArray.push(ExportValue(value[i]));
    }

    return valueArray; // Is Object (array has already been checked)
  } else if (_typeof(value) === 'object' && value !== null) {
    var exportedValue = {};
    Object.keys(value).map(function (key) {
      exportedValue[key] = ExportValue(value[key]);
    });
    return exportedValue; // Is Something Else
  }

  return value;
};

var ValidateObject = function ValidateObject(object, schema) {
  var validator = new _JsonSchema.Validator();
  Object.keys(MODELS).forEach(function (modelKey) {
    var referencedSchema = MODELS[modelKey].schema;

    if (!referencedSchema.id || referencedSchema.id === schema.id) {
      return true;
    }

    validator.addSchema(referencedSchema, referencedSchema.id);
  });
  return validator.validate(object, schema);
};

var AbstractObject = /*#__PURE__*/function () {
  _createClass(AbstractObject, null, [{
    key: "register",
    value: function register(_ref) {
      var name = _ref.name,
          schema = _ref.schema,
          __class = _ref.__class;
      MODELS[name] = {
        schema: schema,
        __class: __class
      };

      if (schema.id) {
        SCHEMA_ID_TO_MODEL_NAME[schema.id] = name;
      }
    }
  }, {
    key: "getSchema",
    value: function getSchema(name) {
      return MODELS[name] && MODELS[name].schema || {};
    }
  }, {
    key: "getClass",
    value: function getClass(name) {
      return MODELS[name] && MODELS[name].__class || Object;
    }
  }]);

  function AbstractObject() {
    _classCallCheck(this, AbstractObject);

    _defineProperty(this, "metadata", {});

    this.metadata = {};
  }

  _createClass(AbstractObject, [{
    key: "getBlu",
    value: function getBlu() {
      console.log("GET BLU");
    }
  }, {
    key: "generateId",
    value: function generateId() {
      // $FlowFixMe
      this.id = "ID_" + Math.random();
    }
  }, {
    key: "getName",
    value: function getName() {
      return "";
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      var _this = this;

      var isEmpty = true;
      var schemaProperties = AbstractObject.getSchema(this.getName()).properties;
      Object.keys(schemaProperties).forEach(function (key) {
        // $FlowFixMe
        if (!IsEmptyValue(_this[key], schemaProperties[key])) {
          isEmpty = false;
          return false;
        }
      });
      return isEmpty;
    }
  }, {
    key: "setData",
    value: function setData(data) {
      var _this2 = this;

      var schemaProperties = AbstractObject.getSchema(this.getName()).properties;
      Object.keys(data).forEach(function (dataKey) {
        if (!schemaProperties[dataKey]) {
          return true;
        } // const validate = ValidateObject(data[dataKey], schemaProperties[dataKey]);
        // if (!validate.valid) {
        //     return true;
        // }
        // $FlowFixMe


        _this2[dataKey] = ConstructValue(data[dataKey], schemaProperties[dataKey]);
      });

      if (data.metadata) {
        this.metadata = data.metadata;
      }
    }
  }, {
    key: "clone",
    value: function clone(modifier) {
      var __class = AbstractObject.getClass(this.getName());

      var clone = new __class.prototype.constructor();
      clone.setData((0, _lodash["default"])(this["export"]()));

      if (modifier) {
        modifier(clone);
      }

      return clone;
    }
  }, {
    key: "export",
    value: function _export() {
      var _this3 = this;

      var schemaProperties = AbstractObject.getSchema(this.getName()).properties;
      var obj = {};
      Object.keys(schemaProperties).forEach(function (property) {
        // $FlowFixMe
        var value = ExportValue(_this3[property]);

        if (value || typeof value === 'boolean') {
          obj[property] = value;
        }
      });
      obj.__class_name = this.getName();
      obj.metadata = this.metadata;
      return obj;
    }
  }, {
    key: "validate",
    value: function validate() {
      var schema = AbstractObject.getSchema(this.getName());
      var validate = ValidateObject(this, schema);

      if (!validate.valid) {
        throw new Error(validate.errors[0]);
      }

      return true;
    }
  }, {
    key: "onSave",
    value: function onSave() {}
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var __class, dbCollection, currentTime, data, result;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.validate();
                __class = AbstractObject.getClass(this.getName());
                dbCollection = __class.getCollection();
                currentTime = Math.floor(new Date().getTime() / 1000);
                data = this["export"]();

                if (!data.metadata) {
                  data.metadata = {};
                }

                if (!this.id) {
                  _context.next = 12;
                  break;
                }

                data.metadata.updatedAt = currentTime;
                _context.next = 10;
                return dbCollection.doc(this.id).set(data);

              case 10:
                _context.next = 18;
                break;

              case 12:
                data.metadata.createdAt = currentTime;
                data.metadata.updatedAt = currentTime;
                _context.next = 16;
                return dbCollection.add(data);

              case 16:
                result = _context.sent;
                this.id = result.id;

              case 18:
                _context.next = 20;
                return this.onSave();

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function save() {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "getCollection",
    value: function getCollection() {
      throw new Error("You forgot to define a 'getCollection' method return db.collection(\"firebaseobjectpath\")");
    }
  }]);

  return AbstractObject;
}();

exports["default"] = AbstractObject;